import React from "react";

import PictureTextRight from "../../PictureTextRight/PictureTextRight";
import styles from './Reason.module.scss'

export default function Reason() {
  return (
    <div className={styles.reasonContainer}>
      <PictureTextRight
        imageUrl="/images/landing_page_pipfarm/image1.png"
        imageAlt="Forex trading"
        imageWidth={607}
        imageHeight={411}
        paragraphTitle="Vì sao bạn chọn cung cấp cTrader?"
        paragraphContent={[
          'cTrader là nền tảng đáng tin cậy nhất mà các quỹ có thể cung cấp. Đây cũng là nền tảng đáng tin cậy nhất cho nhà giao dịch. Khi sử dụng cTrader, nhà giao dịch có thể yên tâm rằng các sàn môi giới và quỹ không thể thao tác điều kiện giao dịch như trên các nền tảng khác.',
          'Các sàn môi giới và quỹ sử dụng cTrader không thể báo giá lại nếu giá di chuyển có lợi cho bạn; họ không thể sửa đổi lệnh của bạn mà không thông báo, và săn stop loss là không thể. Khi một công ty cung cấp cTrader, bạn biết rằng họ minh bạch và trung thực.',
          'Ngoài ra, cTrader còn cung cấp vô số tính năng hỗ trợ giao dịch như cảnh báo giá, cảnh báo mức ký quỹ và cảnh báo khi stop loss không được áp dụng. Nền tảng này cũng giúp các nhà giao dịch thực hiện và quản lý lệnh dễ dàng với các tính năng như kéo thả, giao dịch nhanh với mức lợi nhuận và stop loss xác định sẵn, trailing stop loss và kiểm soát trượt giá.',
        ]}
        imageOrder={2}
        textOrder={1}
      />
    </div>
  );
}
